import { Color } from '@models/color';
import { environment } from '@environments/environment';

export function parseColor(): string {
  const color = new Color(environment.config.colors.primary);
  return color.tinycolor.darken().toHex();
}
